export const VehicleColorType = {
  BLACK: 'rgb(0,0,0)',
  BLUE: 'rgb(25, 118, 210)',
  WHITE: 'rgb(255,255,255)',
  BROWN: 'rgb(93, 64, 55)',
  GRAY: 'rgba(128,128,128,0.5)',
  RED: 'rgb(225, 41, 45)',
  MAROON: 'rgb(128, 0, 0)',
  GREEN: 'rgb(56, 142, 60)',
  SILVER: 'rgba(128,128,128,0.8)',
  BEIGE: 'rgb(245, 245, 220)',
  LIGHTBLUE: 'rgb(66, 165, 245)',
  PURPLE: 'rgb(123, 31, 162)',
  TIEL: 'rgb(0, 121, 107)',
  ORANGE: 'rgb(245, 124, 0)',
  PINK: 'rgb(194, 24, 91)',
  YELLOW: 'rgb(251, 192, 45)',
};
